import { PersonOffRounded } from '@mui/icons-material';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProjectContext } from '../switch-project';

const ExclusionsMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { allowedFeature } = useProjectContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!allowedFeature(Features.EXCLUSIONS)) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/exclusions', { replace: true });
  };

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Lista de Exclusões',
        icon: <PersonOffRounded sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { ExclusionsMenu };
